/**
 * --------------------------------------------------
 * !!! THIS FILE WAS GENERATED BY GRAPHQL-CODEGEN !!!
 * !!!   DO NOT MODIFY THIS FILE BY YOURSELF      !!!
 * --------------------------------------------------
 */

import * as c from "@hex/common";
import type * as Types from "../../generated/graphqlTypes";

import { gql } from "@apollo/client";
import { HexListFragmentDoc } from "../hex-list/HexList.generated";
import {
  CategoryFragmentDoc,
  StatusFragmentDoc,
} from "../app/ProjectLabels.generated";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type GetHexesForHomeQueryVariables = Types.Exact<{
  ownershipLevel: Types.InputMaybe<Types.HexOwnershipLevel>;
  onlyPublished: Types.Scalars["Boolean"]["input"];
  onlyStarred: Types.InputMaybe<Types.Scalars["Boolean"]["input"]>;
  onlyViewed: Types.InputMaybe<Types.Scalars["Boolean"]["input"]>;
  order: Types.InputMaybe<Types.HexOrder>;
  categories: Types.InputMaybe<
    | ReadonlyArray<Types.Scalars["CategoryId"]["input"]>
    | Types.Scalars["CategoryId"]["input"]
  >;
  statuses: Types.InputMaybe<
    | ReadonlyArray<Types.Scalars["StatusId"]["input"]>
    | Types.Scalars["StatusId"]["input"]
  >;
  searchTerm: Types.InputMaybe<Types.Scalars["String"]["input"]>;
  trashed: Types.InputMaybe<Types.Scalars["Boolean"]["input"]>;
  first: Types.InputMaybe<Types.Scalars["Int"]["input"]>;
  last: Types.InputMaybe<Types.Scalars["Int"]["input"]>;
  before: Types.InputMaybe<Types.Scalars["Cursor"]["input"]>;
  after: Types.InputMaybe<Types.Scalars["Cursor"]["input"]>;
  hexTypes: Types.InputMaybe<ReadonlyArray<Types.HexType> | Types.HexType>;
}>;

export type GetHexesForHomeQuery = {
  readonly __typename: "Query";
  readonly hexes: {
    readonly __typename: "HexesConnection";
    readonly pageInfo: {
      readonly __typename: "PageInfo";
      readonly hasPreviousPage: boolean;
      readonly hasNextPage: boolean;
      readonly startCursor: c.Cursor | null;
      readonly endCursor: c.Cursor | null;
    };
    readonly edges: ReadonlyArray<{
      readonly __typename: "HexesEdge";
      readonly node: {
        readonly __typename: "Hex";
        readonly id: c.HexId;
        readonly userUpdatedDate: c.DateTimeString;
        readonly trashDate: c.DateTimeString | null;
        readonly title: string;
        readonly description: c.RichTextDocument | null;
        readonly canShare: boolean;
        readonly maxGrantableRole: Types.ProjectRole | null;
        readonly canViewLogic: boolean;
        readonly effectiveRole: Types.ProjectRole | null;
        readonly starredByViewer: boolean;
        readonly hexType: Types.HexType;
        readonly projectLanguage: Types.ProjectLanguage;
        readonly canDelete: boolean;
        readonly canSetOwner: boolean;
        readonly canEdit: boolean;
        readonly canEditorsShare: boolean;
        readonly archivedDate: c.DateTimeString | null;
        readonly unarchivedDate: c.DateTimeString | null;
        readonly publicRoleV2: Types.ProjectRole | null;
        readonly organizationRoleV2: Types.ProjectRole | null;
        readonly grantSummary: c.ProjectGrantSummary;
        readonly onlyGrantedToCurrentUser: boolean;
        readonly totalViewCount: number;
        readonly currentDraft: {
          readonly __typename: "HexVersion";
          readonly id: c.HexVersionId;
          readonly createdDate: c.DateTimeString;
          readonly title: string;
          readonly logicSessionId: c.AppSessionId;
          readonly canEdit: boolean;
          readonly oAuthSettings: {
            readonly __typename: "HexVersionOAuthSettings";
            readonly id: c.HexVersionOAuthSettingsId;
            readonly logicViewTokenShared: boolean;
          } | null;
          readonly denialReason:
            | {
                readonly __typename: "AssetAccess";
                readonly hasAccessToSharedDataConnections: boolean;
                readonly hasAccessToSharedFiles: boolean;
                readonly hasAccessToSharedPackages: boolean;
                readonly hasAccessToSharedSecrets: boolean;
                readonly hasAccessToSharedSyncRepositories: boolean;
              }
            | { readonly __typename: "MissingProjectRole" }
            | null;
        };
        readonly creator: {
          readonly __typename: "User";
          readonly id: c.UserId;
          readonly name: string | null;
          readonly email: string;
        };
        readonly status: {
          readonly __typename: "Status";
          readonly id: c.StatusId;
          readonly name: string;
          readonly color: Types.HexColor;
          readonly description: string | null;
          readonly inLibrary: boolean;
          readonly endorsed: boolean;
          readonly icon: Types.IconType | null;
        } | null;
        readonly categories: ReadonlyArray<{
          readonly __typename: "Category";
          readonly id: c.CategoryId;
          readonly name: string;
          readonly color: Types.HexColor;
          readonly description: string | null;
        }>;
        readonly lastPublishedVersion: {
          readonly __typename: "HexVersion";
          readonly id: c.HexVersionId;
        } | null;
        readonly owner: {
          readonly __typename: "User";
          readonly id: c.UserId;
          readonly name: string | null;
          readonly email: string;
        };
        readonly org: {
          readonly __typename: "Org";
          readonly id: c.OrgId;
          readonly displayName: string;
          readonly allowPublicSharing: boolean;
          readonly resolvedAllowPublicSharing: boolean;
        };
        readonly projectAnalytics: {
          readonly __typename: "HexAnalytics";
          readonly id: c.HexAnalyticsId;
          readonly totalViewsLast7Days: number;
          readonly totalViewsLast14Days: number;
          readonly totalViewsLast30Days: number;
        };
      };
    }>;
  };
};

export type GetProjectLabelsForHomeQueryVariables = Types.Exact<{
  orgId: Types.Scalars["OrgId"]["input"];
}>;

export type GetProjectLabelsForHomeQuery = {
  readonly __typename: "Query";
  readonly orgById: {
    readonly __typename: "Org";
    readonly id: c.OrgId;
    readonly categories: ReadonlyArray<{
      readonly __typename: "Category";
      readonly id: c.CategoryId;
      readonly name: string;
      readonly color: Types.HexColor;
      readonly description: string | null;
    }>;
    readonly statuses: ReadonlyArray<{
      readonly __typename: "Status";
      readonly id: c.StatusId;
      readonly name: string;
      readonly color: Types.HexColor;
      readonly description: string | null;
      readonly inLibrary: boolean;
      readonly endorsed: boolean;
      readonly icon: Types.IconType | null;
    }>;
  };
};

export const GetHexesForHomeDocument = /*#__PURE__*/ gql`
  query GetHexesForHome(
    $ownershipLevel: HexOwnershipLevel
    $onlyPublished: Boolean!
    $onlyStarred: Boolean
    $onlyViewed: Boolean
    $order: HexOrder
    $categories: [CategoryId!]
    $statuses: [StatusId!]
    $searchTerm: String
    $trashed: Boolean
    $first: Int
    $last: Int
    $before: Cursor
    $after: Cursor
    $hexTypes: [HexType!]
  ) {
    hexes(
      ownershipLevel: $ownershipLevel
      onlyPublished: $onlyPublished
      onlyStarred: $onlyStarred
      onlyViewed: $onlyViewed
      order: $order
      categories: $categories
      statuses: $statuses
      searchTerm: $searchTerm
      trashed: $trashed
      first: $first
      last: $last
      before: $before
      after: $after
      hexTypes: $hexTypes
      archived: EXCLUDE
    ) {
      pageInfo {
        hasPreviousPage
        hasNextPage
        startCursor
        endCursor
      }
      edges {
        node {
          id
          ...HexListFragment
        }
      }
    }
  }
  ${HexListFragmentDoc}
`;

/**
 * __useGetHexesForHomeQuery__
 *
 * To run a query within a React component, call `useGetHexesForHomeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHexesForHomeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHexesForHomeQuery({
 *   variables: {
 *      ownershipLevel: // value for 'ownershipLevel'
 *      onlyPublished: // value for 'onlyPublished'
 *      onlyStarred: // value for 'onlyStarred'
 *      onlyViewed: // value for 'onlyViewed'
 *      order: // value for 'order'
 *      categories: // value for 'categories'
 *      statuses: // value for 'statuses'
 *      searchTerm: // value for 'searchTerm'
 *      trashed: // value for 'trashed'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *      hexTypes: // value for 'hexTypes'
 *   },
 * });
 */
export function useGetHexesForHomeQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetHexesForHomeQuery,
    GetHexesForHomeQueryVariables
  > &
    (
      | { variables: GetHexesForHomeQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetHexesForHomeQuery, GetHexesForHomeQueryVariables>(
    GetHexesForHomeDocument,
    options,
  );
}
export function useGetHexesForHomeLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetHexesForHomeQuery,
    GetHexesForHomeQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetHexesForHomeQuery,
    GetHexesForHomeQueryVariables
  >(GetHexesForHomeDocument, options);
}
export function useGetHexesForHomeSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetHexesForHomeQuery,
    GetHexesForHomeQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetHexesForHomeQuery,
    GetHexesForHomeQueryVariables
  >(GetHexesForHomeDocument, options);
}
export type GetHexesForHomeQueryHookResult = ReturnType<
  typeof useGetHexesForHomeQuery
>;
export type GetHexesForHomeLazyQueryHookResult = ReturnType<
  typeof useGetHexesForHomeLazyQuery
>;
export type GetHexesForHomeSuspenseQueryHookResult = ReturnType<
  typeof useGetHexesForHomeSuspenseQuery
>;
export type GetHexesForHomeQueryResult = Apollo.QueryResult<
  GetHexesForHomeQuery,
  GetHexesForHomeQueryVariables
>;
export const GetProjectLabelsForHomeDocument = /*#__PURE__*/ gql`
  query GetProjectLabelsForHome($orgId: OrgId!) {
    orgById(orgId: $orgId) {
      id
      categories {
        ...CategoryFragment
      }
      statuses {
        ...StatusFragment
      }
    }
  }
  ${CategoryFragmentDoc}
  ${StatusFragmentDoc}
`;

/**
 * __useGetProjectLabelsForHomeQuery__
 *
 * To run a query within a React component, call `useGetProjectLabelsForHomeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectLabelsForHomeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectLabelsForHomeQuery({
 *   variables: {
 *      orgId: // value for 'orgId'
 *   },
 * });
 */
export function useGetProjectLabelsForHomeQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetProjectLabelsForHomeQuery,
    GetProjectLabelsForHomeQueryVariables
  > &
    (
      | { variables: GetProjectLabelsForHomeQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetProjectLabelsForHomeQuery,
    GetProjectLabelsForHomeQueryVariables
  >(GetProjectLabelsForHomeDocument, options);
}
export function useGetProjectLabelsForHomeLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetProjectLabelsForHomeQuery,
    GetProjectLabelsForHomeQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetProjectLabelsForHomeQuery,
    GetProjectLabelsForHomeQueryVariables
  >(GetProjectLabelsForHomeDocument, options);
}
export function useGetProjectLabelsForHomeSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetProjectLabelsForHomeQuery,
    GetProjectLabelsForHomeQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetProjectLabelsForHomeQuery,
    GetProjectLabelsForHomeQueryVariables
  >(GetProjectLabelsForHomeDocument, options);
}
export type GetProjectLabelsForHomeQueryHookResult = ReturnType<
  typeof useGetProjectLabelsForHomeQuery
>;
export type GetProjectLabelsForHomeLazyQueryHookResult = ReturnType<
  typeof useGetProjectLabelsForHomeLazyQuery
>;
export type GetProjectLabelsForHomeSuspenseQueryHookResult = ReturnType<
  typeof useGetProjectLabelsForHomeSuspenseQuery
>;
export type GetProjectLabelsForHomeQueryResult = Apollo.QueryResult<
  GetProjectLabelsForHomeQuery,
  GetProjectLabelsForHomeQueryVariables
>;
